import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { ApolloProvider } from 'react-apollo';
import ApolloClient from 'apollo-client';
import WebFont from 'webfontloader';

// Setup the network "links"
import { WebSocketLink } from 'apollo-link-ws';
import { HttpLink } from 'apollo-link-http';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache } from 'apollo-cache-inmemory';
import * as Sentry from '@sentry/browser';

import { selectAuthorizedAuthState } from './redux/selectors/auth';
import { ReduxState } from './redux/reducers/global';
import { authenticate } from './redux/actions/auth';
import Router from './components/Router';
import SignInTabs from './components/auth/SignInTabs';
import SentryErrorBoundary from './SentryErrorBoundary';

const httpLink = new HttpLink({
	uri: `https://${process.env.REACT_APP_GRAPHQL_ENDPOINT}`
});

const wsLink = new WebSocketLink({
	uri: `wss://${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
	options: {
		reconnect: true
	}
});

const link = split(
	({ query }) => {
		const definition = getMainDefinition(query);
		return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
	},
	wsLink,
	httpLink
);

const client = new ApolloClient({
	link,
	cache: new InMemoryCache()
});

class App extends Component<any, any> {
	componentDidMount() {
		const { auth, authenticate } = this.props;
		// tslint:disable-next-line: no-console
		console.log('process.env', process.env);
		if (!auth) {
			authenticate();
		}
	}

	render() {
		Sentry.init({ dsn: 'https://65d45022572c47a29371f4e16aef05c3@o396861.ingest.sentry.io/5250785' });

		WebFont.load({
			google: {
				families: ['Quicksand:400,700', 'sans-serif']
			}
		});

		const { auth } = this.props;

		if (auth) {
			return (
				<ApolloProvider client={client}>
					<SentryErrorBoundary>
						<Router />
					</SentryErrorBoundary>
				</ApolloProvider>
			);
		}
		return (
			<ApolloProvider client={client}>
				<SentryErrorBoundary>
					<SignInTabs />
				</SentryErrorBoundary>
			</ApolloProvider>
		);
	}
}

const mapStateToProps = (state: ReduxState) => {
	const auth = selectAuthorizedAuthState(state);

	return {
		auth
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ authenticate }, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(App);
